import { FilesTableExportDesignMenuItem } from './tables/files/menu/files-table-export-design.menu-item';

export enum ContributionsEnum {
  DRIVE_CYCLE_TABLE_ID = 'drive-cycle-table',
  DRIVE_CYCLE_TABLE_MENU_COLUMN = 'drive-cycle-menu-column',
  DRIVE_CYCLE_MENU_ID = 'drive-cycle-more-menu',
  DRIVE_CYCLE_TABLE_MENU_ID = 'drive-cycle-menu',
  DRIVE_CYCLE_MORE_MENU_ITEM = 'drive-cycle-more-menu-item',
  DRIVE_CYCLE_MENU_ITEM_DELETE_ID = 'drive-cycle-delete-menu',
  DRIVE_CYCLE_TABLE_SELECTED_COLUMN = 'drive-cycle-selected-column',
  DRIVE_CYCLE_TABLE_NAME_COLUMN = 'drive-cycle-name-column',
  DRIVE_CYCLE_TABLE_NUMBER_OF_POINTS_COLUMN = 'drive-cycle-table-number-of-points-column',
  DRIVE_CYCLE_TABLE_TOTAL_TIME_COLUMN = 'drive-cycle-table-total-time-column',
  DRIVE_CYCLE_TABLE_TOTAL_DISTANCE_COLUMN = 'drive-cycle-table-total-distance-column',
  LIBRARY_TABLE_DESCRIPTION_COLUMN = 'library-table-description',
  LIBRARY_TABLE_ICON_COLUMN = 'library-table-icon',
  LIBRARY_TABLE_TYPE_COLUMN = 'library-table-type',
  FILES_TABLE_LOGO_COLUMN = 'files-table-logo',
  FILES_TABLE_CREATE_PROJECT_FROM_DESIGN_MENU_ITEM = 'files-table-create-project-from-design-menu-item',
  FILES_TABLE_EXPORT_DESIGN_MENU_ITEM = 'files-table-export-design-menu-item',
  FILES_TABLE_RENAME_MENU_ITEM = 'files-table-rename-menu-item',
  STUDY_TABLE_PROJECT_COLUMN = 'study-project-column',
  USER_PROFILE_MENU_ABOUT_MENU_ITEM = 'user-profile-menu-about',
  USER_PROFILE_MENU_FEATURE_FLAG_MENU_ITEM = 'user-profile-menu-feature-flag',
  USER_PROFILE_MENU_HELP_MENU_ITEM = 'user-profile-menu-help',
  IMPORT_FROM_FILE_MENU_ITEM = 'import-from-file-menu-item',
}
